import type {CSSProperties} from 'react';

export interface SocialPostPreviewSkeletonProps {
  cardStyle?: CSSProperties;
}

/** Shared by the bars; the avatar, the badge and the full-bleed media each set their own. */
export const PREVIEW_SKELETON_BLOCK_RADIUS = '8px';

/** The badge keeps the tighter radius of the platform mark it stands in for. */
export const PREVIEW_SKELETON_BADGE_RADIUS = '4px';

/** Block sizes from the loading-state design, in px. The media block is sized by flex, not here. */
export const PREVIEW_SKELETON_AVATAR_SIZE = 32;
export const PREVIEW_SKELETON_BADGE_SIZE = 20;
export const PREVIEW_SKELETON_ACCOUNT_NAME_WIDTH = 64;
export const PREVIEW_SKELETON_ACCOUNT_NAME_HEIGHT = 13;
export const PREVIEW_SKELETON_ACCOUNT_META_WIDTH = 42;
export const PREVIEW_SKELETON_ACCOUNT_META_HEIGHT = 10;
export const PREVIEW_SKELETON_CAPTION_HEIGHT = 13;
export const PREVIEW_SKELETON_CAPTION_LAST_LINE_WIDTH = 155;
export const PREVIEW_SKELETON_ACTION_HEIGHT = 13;
export const PREVIEW_SKELETON_LEADING_ACTION_WIDTH = 105;
export const PREVIEW_SKELETON_TRAILING_ACTION_WIDTH = 94;
